import InvitationStudent from '@/views/Invitation/Student/index.vue'
import InvitationSenior from '@/views/Invitation/Senior/index.vue'
import InvitationOrder from '@/views/Invitation/Order/index.vue'
import MatchingOrder from '@/views/Invitation/MatchingOrder/index.vue'
import FosterOrder from '@/views/Invitation/FosterOrder/index.vue'
import TargetRecruit from '@/views/TargetRecruit/index.vue'

export default [
  {
    path: '/user/invitation-student',
    component: InvitationStudent,
    meta: { title: '邀请学生' },
  },
  {
    path: '/user/invitation-senior',
    component: InvitationSenior,
    meta: { title: '邀请学长' },
  },
  {
    path: '/user/target-recruit',
    component: TargetRecruit,
    meta: { title: '报录比分析' },
  },
  {
    path: '/order/invitation-order',
    component: InvitationOrder,
    meta: { title: '邀请订单' },
  },
  {
    path: '/order/master-order',
    component: FosterOrder,
    props: { mode: 'master' },
    meta: { title: '主理订单' },
  },
  {
    path: '/order/ally-order',
    component: FosterOrder,
    props: { mode: 'ally' },
    meta: { title: '合作订单' },
  },
  {
    path: '/order/matching-order',
    component: MatchingOrder,
    meta: { title: '匹配订单' },
  },
]
